import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link, useParams } from 'react-router-dom'
import config from '../config'
import { useDispatch, useSelector } from 'react-redux'
import { getBooths, getHalls } from '../ducks/booth'
import Amplitude from '../utils/amplitudeHelper'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import LoadIcon from '../components/LoadIcon'
import { COLORS, SIZES } from '../styles/theme'

const Page = styled.div`
  overflow: hidden;
  background-image: ${(props)=> `url(${props.hallBg})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: calc(100vh - ${SIZES.navHeight});
  padding-top: 30px;
  top: ${SIZES.navHeight};
  position: relative;

  .prev-btn, .next-btn {
    position: absolute;
    bottom: 8vh;
    text-decoration: none;
    background: linear-gradient(#FF9821, #F83636);
    color: ${COLORS.hotButtonText};
    border-radius: 32px;
    border: 2px solid #FF9821;
    padding: 8px 16px;
    text-align: center;
    box-shadow: 0px 5px 4px -4px #000;
    p {
      margin: 0 auto;
    }
  }
  .prev-btn {
    left: 5%;
  }
  .next-btn {
    right: 5%;
  }
  #hall {
    padding: 28vh 0px;
    padding-bottom: 100px;
    margin: 0 auto;
    width: 80%;
    height: 100%;
  }
  .grid {
    width: 100%;
    height: 50%;
    display: grid;
  }
  .byThree {
    grid-template-columns: repeat(3, 1fr) ;
  }
  .byFour {
    grid-template-columns: repeat(4, 1fr) ;
  }
  .byFive {
    grid-template-columns: repeat(5, 1fr) ;
  }
  a, button {
    text-align: center;
  }
  
  .booths {
    margin: 0 auto;
    margin: 10px;
    margin-top: 20px;
    height: 20vh;
    -webkit-transition: margin 0.2s ease-out;
    -moz-transition: margin 0.2s ease-out;
    -o-transition: margin 0.2s ease-out;

    &:hover {
      cursor:pointer;
      margin-top: 5px;
    }
  }
`

export default function ExhibitionPage({ currentUser }) {
  const dispatch = useDispatch()
  const params = useParams()
  const { booths, halls, apiLoading } = useSelector((state) => state.booth)
  const hallNumber = parseInt(params.hallId)
  const [rows, setRows] = useState([])
  const boothPerRow = {
    1 : [4,5],
    2 : [5,5],
    3 : [3,4],
  }

  useEffect(() => {
    dispatch(getBooths(hallNumber))
    dispatch(getHalls())
    setRows(boothPerRow[hallNumber])
  }, [hallNumber, dispatch])


  useEffect(() => {
    document.title = `${config.eventName} | Exhibition Hall`
  }, [])

  useEffect(() => {
    Amplitude.visitExhibition(hallNumber)
  }, [currentUser.id, hallNumber])

  const getNextHall = () => {
    return hallNumber+1
  }
  const getPreviousHall = () => {
    return hallNumber-1
  }

  const getNextHallName = () => {
    if (hallNumber === halls.length-1) {
      return null
    }
    const hall = halls.filter(item=>item.id === hallNumber+1)[0]
    return hall
  }
  const getPreviousHallName = () => {
    if (hallNumber === 1) {
      return null
    }
    const hall = halls.filter(item=>item.id === hallNumber-1)[0]
    return hall
  }

  if (apiLoading) {
    return <LoadIcon />
  }
  return (
    <>
      { apiLoading && <LoadIcon /> }
      <Page hallBg={config.assets.exhibition1}  >
        <div id="hall">
          <div className={`${rows[0] === 3 ?  "byThree" : rows[0] === 4 ? "byFour" : "byFive"} grid`}>
            {booths.slice(0, rows[0]).map((booth) => (
              <Link to={`/booths/${booth.id}`} key={booth.thumbnail.filename}>
                <LazyLoadImage className="booths" src={booth.thumbnail.url} alt="booth" effect="opacity" />
              </Link>
            ))}
          </div>
          <div className={`${rows[1] === 4 ?  "byFour" : "byFive"} grid`}>
            {booths.slice(rows[0], booths.length).map((booth) => (
              <Link to={`/booths/${booth.id}`} key={booth.thumbnail.filename}>
                <LazyLoadImage className="booths" src={booth.thumbnail.url} alt="booth" effect="opacity" />
              </Link>
            ))}
          </div>
          {getPreviousHallName() && (
            <Link to={`/exhibition-hall/${getPreviousHall()}`} className="prev-btn" >
              <p>
                <svg width="13px" height="22px" viewBox="0 0 13 22">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-209.000000, -3123.000000)">
                      <g transform="translate(100.000000, 3068.000000)">
                        <g transform="translate(103.000000, 54.000000)">
                          <polygon points="0 0 24 0 24 24 0 24"></polygon>
                          <path fill={COLORS.hotButtonText} d="M13.5,5.5 C14.6,5.5 15.5,4.6 15.5,3.5 C15.5,2.4 14.6,1.5 13.5,1.5 C12.4,1.5 11.5,2.4 11.5,3.5 C11.5,4.6 12.4,5.5 13.5,5.5 Z M9.8,8.9 L7.24,21.81 C7.11,22.42 7.59,23 8.22,23 L8.3,23 C8.77,23 9.17,22.68 9.28,22.22 L10.9,15 L13,17 L13,22 C13,22.55 13.45,23 14,23 C14.55,23 15,22.55 15,22 L15,16.36 C15,15.81 14.78,15.29 14.38,14.91 L12.9,13.5 L13.5,10.5 C14.57,11.74 16.12,12.63 17.86,12.91 C18.46,13 19,12.52 19,11.91 C19,11.42 18.64,11.01 18.15,10.93 C16.63,10.68 15.37,9.78 14.7,8.6 L13.7,7 C13.14,6.11 12.02,5.75 11.05,6.16 L7.22,7.78 C6.48,8.1 6,8.82 6,9.63 L6,12 C6,12.55 6.45,13 7,13 C7.55,13 8,12.55 8,12 L8,9.6 L9.8,8.9 Z"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </p>
              <p>To {getPreviousHallName().name}</p>
            </Link>
          )}
          {getNextHallName() && (
            <Link to={`/exhibition-hall/${getNextHall()}`} className="next-btn" >
              <p>
                <svg width="13px" height="22px" viewBox="0 0 13 22">
                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-209.000000, -3123.000000)">
                      <g transform="translate(100.000000, 3068.000000)">
                        <g transform="translate(103.000000, 54.000000)">
                          <polygon points="0 0 24 0 24 24 0 24"></polygon>
                          <path fill={COLORS.hotButtonText} d="M13.5,5.5 C14.6,5.5 15.5,4.6 15.5,3.5 C15.5,2.4 14.6,1.5 13.5,1.5 C12.4,1.5 11.5,2.4 11.5,3.5 C11.5,4.6 12.4,5.5 13.5,5.5 Z M9.8,8.9 L7.24,21.81 C7.11,22.42 7.59,23 8.22,23 L8.3,23 C8.77,23 9.17,22.68 9.28,22.22 L10.9,15 L13,17 L13,22 C13,22.55 13.45,23 14,23 C14.55,23 15,22.55 15,22 L15,16.36 C15,15.81 14.78,15.29 14.38,14.91 L12.9,13.5 L13.5,10.5 C14.57,11.74 16.12,12.63 17.86,12.91 C18.46,13 19,12.52 19,11.91 C19,11.42 18.64,11.01 18.15,10.93 C16.63,10.68 15.37,9.78 14.7,8.6 L13.7,7 C13.14,6.11 12.02,5.75 11.05,6.16 L7.22,7.78 C6.48,8.1 6,8.82 6,9.63 L6,12 C6,12.55 6.45,13 7,13 C7.55,13 8,12.55 8,12 L8,9.6 L9.8,8.9 Z"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </p>
              <p>To {getNextHallName().name}</p>
            </Link>
          )}
        </div>
      </Page>
    </>
  )
}
